import { Injectable } from '@angular/core';
import { PaymentMethodModel } from 'src/app/core/models/payment-method.model';
import { HttpClient } from '@angular/common/http';
import { BaseService } from 'src/app/core/base/base.service';
import { ObjectApiInterface } from '../../../../core/base/interfaces/object-api.interface';
import { AuthService } from '../../../../core/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentMethodService extends BaseService<PaymentMethodModel> {
  defaultSort = 'label';

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) {
    super(http, 'payment-method', authService);
  }

  checkDependencies(model: PaymentMethodModel) {
    return this.http.post<ObjectApiInterface<any>>(`${this.baseUrlApi}/checkDependencies/${model._id}`, {});
  }

  changeAndArchiveGeneric(_id: string, body: any) {
    return this.http.post<ObjectApiInterface<any>>(`${this.baseUrlApi}/changeAndArchiveGeneric/${_id}`, body);
  }

  changeAndDeleteGeneric(_id: string, body: any) {
    return this.http.post<ObjectApiInterface<any>>(`${this.baseUrlApi}/changeAndDeleteGeneric/${_id}`, body);
  }

  changeAndUpdateGeneric(_id: string, body: any) {
    return this.http.post<ObjectApiInterface<any>>(`${this.baseUrlApi}/changeAndUpdateGeneric/${_id}`, body);
  }
}
